import { useTranslation } from 'react-i18next'
import { Users, MessageSquare, Link, Layers } from 'lucide-react'
import type { NetworkGraphStatsDTO } from '../model/contracts'

interface Props {
  stats: NetworkGraphStatsDTO
}

export function NetworkHeaderKpis({ stats }: Props) {
  const { t } = useTranslation('network')

  const cards = [
    { icon: Users, label: t('kpi.authors'), value: stats.authors },
    { icon: MessageSquare, label: t('kpi.comments'), value: stats.comments },
    { icon: Link, label: t('kpi.links'), value: stats.links },
    { icon: Layers, label: t('kpi.groups'), value: stats.groups },
  ]

  return (
    <div className="flex flex-wrap gap-3">
      {cards.map(({ icon: Icon, label, value }) => (
        <div
          key={label}
          className="flex flex-1 items-center gap-3 rounded-xl border border-border bg-card px-4 py-3"
        >
          <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
          <div className="min-w-0">
            <p className="truncate text-xs text-muted-foreground">{label}</p>
            <p className="text-lg font-semibold text-foreground">
              {value.toLocaleString()}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}
